// mission-cost-accounting-types.ts
//
// Shared types/constant between mission-cost-accounting.ts and
// mission-cost-journal-reader.ts (split out in the same P13-review pass as
// must-fix #2 — code-reviewer-260910-p13-bc.md) so neither file needs to
// import the other just to get at `MissionCostSummary`/the event kind
// string, avoiding a circular import between the two.
export const ATTEMPT_USAGE_RECORDED_KIND = "attempt_usage_recorded" as const;

export interface MissionCostSummary {
  total_input_tokens: number;
  total_output_tokens: number;
  /** Undefined only when NO recorded attempt ever carried a cost figure. */
  total_cost_usd: number | undefined;
  // D15 (phase 05 Req 8, nhánh a): counted from `attempt_started` — includes
  // attempts killed/SIGINT'd/unlocked before ever emitting
  // `attempt_usage_recorded` (was undercounted before this phase — a killed
  // attempt vanished from these two fields entirely).
  attempts_total: number;
  attempts_by_ticket: Record<string, number>;
  /** Phase 05 Req 8: `attempts_total` minus attempts that DID emit `attempt_usage_recorded` — the cost total above never includes these. */
  attempts_without_usage: number;
}
